<!-- ════════════════ LAYOUT VERTICAL (Fase 1) ════════════════
     3 variantes: completed | next | pending. El card es flex-column con
     justify-content:space-between. -->
<article *ngIf="layout === 'vertical'" class="task-card" [ngClass]="'task-card--' + variant" [class.task-card--large]="large" (click)="onClick()">
    <!-- PÍLDORA DE TIEMPO (solo pending) — absoluta, fuera del flujo flex. -->
    <div class="task-card__time-pill" *ngIf="variant === 'pending'">
        <fa-icon [icon]="['fas', 'clock']" class="task-card__time-icon"></fa-icon>
        {{ task.time_label }}
    </div>

    <!-- FILA SUPERIOR -->
    <div class="task-card__top">
        <span class="task-card__check" *ngIf="variant === 'completed'">
            <fa-icon [icon]="['fas', 'check']"></fa-icon>
        </span>
        <span class="task-card__icon" *ngIf="variant !== 'completed'">
            <fa-icon [icon]="['fas', moduleIcon]" class="task-card__icon-glyph"></fa-icon>
            <span class="task-card__plus">
                <fa-icon [icon]="['fas', 'plus']"></fa-icon>
            </span>
        </span>

        <h3 class="task-card__title" *ngIf="variant === 'completed'">{{ task.title }}</h3>

        <span class="task-card__badge task-card__badge--done" *ngIf="variant === 'completed'">Completado</span>
        <span class="task-card__badge task-card__badge--next" *ngIf="variant === 'next'">Siguiente paso</span>
    </div>

    <!-- TÍTULO (next / pending) -->
    <h3 class="task-card__title" *ngIf="variant !== 'completed'">{{ task.title }}</h3>

    <!-- ELEMENTO INFERIOR -->
    <div class="task-card__detail" *ngIf="variant === 'completed' && task.completed_detail">
        <span class="task-card__detail-label">{{ task.completed_detail.label }}</span>
        <span class="task-card__detail-value">{{ task.completed_detail.value }}</span>
    </div>

    <span class="task-card__time" *ngIf="variant === 'next'">
        <fa-icon [icon]="['fas', 'clock']" class="task-card__time-icon"></fa-icon>
        {{ task.time_label }}
    </span>
</article>

<!-- ════════════════ LAYOUT HORIZONTAL (Fase 2) ════════════════
     Barra: [check/ícono] [título + descripción (+ OBLIGATORIO)] [XP | botón "Ir →"].
     completada → check verde + título tachado + "+N XP".
     pendiente  → ícono módulo + título + descripción + (OBLIGATORIO si is_mandatory) + botón "Ir →". -->
<article *ngIf="layout === 'horizontal'" class="task-bar" [ngClass]="'task-bar--' + variant" [class.theme-green]="theme === 'green'" (click)="onClick()">
    <!-- IZQUIERDA -->
    <span class="task-bar__check" *ngIf="variant === 'completed'">
        <fa-icon [icon]="['fas', 'check']"></fa-icon>
    </span>
    <span class="task-bar__icon" *ngIf="variant !== 'completed'">
        <fa-icon [icon]="['fas', moduleIcon]" class="task-bar__icon-glyph"></fa-icon>
    </span>

    <!-- CENTRO -->
    <div class="task-bar__body">
        <div class="task-bar__title-row">
            <span class="task-bar__title">{{ task.title }}</span>
            <span class="task-bar__mandatory" *ngIf="task.is_mandatory && variant !== 'completed'">OBLIGATORIO</span>
        </div>
        <span class="task-bar__desc" *ngIf="task.description">{{ task.description }}</span>
    </div>

    <!-- DERECHA -->
    <span class="task-bar__xp" *ngIf="variant === 'completed' && task.reward_xp">+{{ task.reward_xp }} XP</span>

    <div class="task-bar__actions" *ngIf="variant !== 'completed'">
        <button type="button" class="task-bar__cta" (click)="$event.stopPropagation(); onClick()">
            {{ actionLabel }}
            <fa-icon [icon]="['fas', 'arrow-right']"></fa-icon>
        </button>
    </div>
</article>
